module.exports = __webpack_public_path__ + "static/media/solar-panels.1abab123.png";